import { lazy } from 'react';
import { EnumBehaviorKey } from 'src/types/Behaviors';
import { AppRoute } from 'src/types/Route';

const ListCampus = lazy(
  () =>
    import(
      /* webpackChunkName: "ListCampus" */ 'src/pages/Backstage/subPages/Base/ListCampus'
    ),
);

const ListInstitute = lazy(
  () =>
    import(
      /* webpackChunkName: "ListInstitute" */ 'src/pages/Backstage/subPages/Base/ListInstitute'
    ),
);

const ListFaculty = lazy(
  () =>
    import(
      /* webpackChunkName: "ListFaculty" */ 'src/pages/Backstage/subPages/Base/ListInstitute/subPages/ListFaculty'
    ),
);

const ListMajor = lazy(
  () =>
    import(
      /* webpackChunkName: "ListMajor" */ 'src/pages/Backstage/subPages/Base/ListMajor'
    ),
);

const ListClazz = lazy(
  () =>
    import(
      /* webpackChunkName: "ListClazz" */ 'src/pages/Backstage/subPages/Base/ListClazz'
    ),
);

const ListStudent = lazy(
  () =>
    import(
      /* webpackChunkName: "ListStudent" */ 'src/pages/Backstage/subPages/Base/ListClazz/subPages/ListStudent'
    ),
);

const ListOrganization = lazy(
  () =>
    import(
      /* webpackChunkName: "ListOrganization" */ 'src/pages/Backstage/subPages/Base/ListOrganization'
    ),
);

const OrganizationTree = lazy(
  () =>
    import(
      /* webpackChunkName: "OrganizationTree" */ 'src/pages/Backstage/subPages/Base/ListOrganization/subPages/OrganizationTree'
    ),
);

const ListPosition = lazy(
  () =>
    import(
      /* webpackChunkName: "ListPosition" */ 'src/pages/Backstage/subPages/Base/ListPosition'
    ),
);

const baseRoutes: AppRoute[] = [
  {
    name: '校区设置',
    path: '/backstage/base/list-campus',
    Component: ListCampus,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '院系设置',
    path: '/backstage/base/list-institute',
    Component: ListInstitute,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '查看系',
    path: '/backstage/base/list-faculty',
    Component: ListFaculty,
    hideInPanel: true,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '专业设置',
    path: '/backstage/base/list-major',
    Component: ListMajor,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '班级管理',
    path: '/backstage/base/list-clazz',
    Component: ListClazz,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '班级学生',
    path: '/backstage/base/list-student',
    Component: ListStudent,
    hideInPanel: true,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '组织管理',
    path: '/backstage/base/list-organization',
    Component: ListOrganization,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '组织架构图',
    path: '/backstage/base/organization-tree',
    Component: OrganizationTree,
    hideInPanel: true,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '职位管理',
    path: '/backstage/base/list-position',
    Component: ListPosition,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
];

export default baseRoutes;
